import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiRequestService } from './../../../../BaseFramework/core/http/api-request.service';
import { AgentService } from './../../../../BaseFramework/core/http';
import { ClientPersonDO, ClientOrgnizationDO, AgentDO, ClientAddressDO, ClientContactDO, ClientEmailDO, PolicyAdditionalFieldDO } from '../../../shared/models'
import { PersonDO } from 'app/BaseFramework/shared/models/Global.model';
import { ValidationUtilService } from '../../../core/services/validations/validationsUtil.service'
import { GuidGenerator } from '../../../core/utilities'
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { AppMetadataHandler } from '../../../configs/app-metadata.handler'
import { ClientService } from '../../../core/http/client.service'
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
/* Dependencies: FormsModule & ReactiveFormsModule */

@Component({
  selector: 'app-org-agents',
  templateUrl: './org-agents.component.html',
  styleUrls: ['./org-agents.component.scss']
})
export class OrgAgentsComponent implements OnInit {

  constructor(
    private apiRequest: ApiRequestService,
    private fb: FormBuilder,
    public validationUtilService: ValidationUtilService,
    private commonUtilty: GuidGenerator,
    private agentService: AgentService,
    private msg: NzMessageService,
    private notification: NzNotificationService,
    public appMetadataHandler: AppMetadataHandler,
    private clientService: ClientService,
    private translateService:TranslateService,
  ) { }

  @ViewChild(FormGroup) products !: FormGroup;
  validateForm: FormGroup
  public productForm: FormGroup;
  userRoleCd: any;
  userStatusCd: any;
  clientTypeCd: any;
  contactPersonLookup: any;
  agentDesignationCd: any;
  channelCdLookup: any;
  subChannelCdLookup: any;
  agentCategoryCd: any;

  divisionCdLookup: any;
  subDivisionCd: any;
  subDivisionCdFiltered: any;

  partnerNames: any;
  branchNames: any;

  provinces: any;
  productsList: any;
  countryCd: any;
  countryLookup: any;
  countryCdDdDisabled: boolean = true;
  cityCdLookup: any;
  listObservable
  NULLVALUE = null
  selectedSearchCriteria = null
  selectedSearchValue = null
  CRITERIALOOKUP = [
    {
      "key": "agentNum",
      "value": "Agent Number",
      "valueInputType": "text"
    },
    {
      "key": "channelCd",
      "value": "Channel Code",
      "valueInputType": "dropdown"
    },
    {
      "key": "subChannelCd",
      "value": "Sub Channel Code",
      "valueInputType": "dropdown"
    },
    {
      "key": "partnerCd",
      "value": "Partner Code",
      "valueInputType": "dropdown"
    },
    {
      "key": "partnerbranchCd",
      "value": "Partner Branch Code",
      "valueInputType": "dropdown"
    },
    {
      "key": "firstName",
      "value": "First Name",
      "valueInputType": "text"
    },
    {
      "key": "lastName",
      "value": "Last Name",
      "valueInputType": "text"
    },
    {
      "key": "companyName",
      "value": "Company Name",
      "valueInputType": "dropdown"
    },
    {
      "key": "clientType",
      "value": "Client Type",
      "valueInputType": "dropdown"
    }
  ]

  criteriaItemDO = {
    "paramName": null,
    "paramValue": null
  }

  searchCriteria1 = {
    "searchCriteriaList": [
      {
        "paramName": "agentNum",
        "paramValue": null
      },
      {
        "paramName": "channelCd",
        "paramValue": null
      },
      {
        "paramName": "subChannelCd",
        "paramValue": null
      },
      {
        "paramName": "partnerCd",
        "paramValue": null
      },
      {
        "paramName": "partnerbranchCd",
        "paramValue": null
      },
      {
        "paramName": "firstName",
        "paramValue": null
      },
      {
        "paramName": "lastName",
        "paramValue": null
      },
      {
        "paramName": "companyName",
        "paramValue": null
      },
      {
        "paramName": "licenseExpiryDt",
        "paramValue": null
      },
      {
        "paramName": "clientType",
        "paramValue": ""
      }
    ],
    "page": 0,
    "size": 10
  }

  searchCriteria = {
    "searchCriteriaList": [
      {
        "paramName": "clientType",
        "paramValue": ""
      }
    ],
    "page": 0,
    "size": 10
  }

  messageId: any;
  ngOnInit() {

    /* Simulate client error * /
    setTimeout(() => {
      throw new Error('Client Error');
    }, 4567);
    /* */


    this.fetchAgentList()




    /* Products */
    this.productForm = this.fb.group({
      products: this.fb.array([this.initItemRows()])
    });


    this.initializeNewAgentRegistrationForm();
    this.translateService.use(this.appMetadataHandler.defaultLanguage)

    ///this.apiRequest.get("labelData/findByLanguageCdCSV/EN,BH").subscribe( data=> console.log(data));

  }

  fetchAgentList() {
    this.agentsDataSet = null
    this.messageId = this.msg.loading('Fetching ...').messageId;
    if (this.listObservable != null)
      this.listObservable.unsubscribe();
    this.listObservable = this.apiRequest.get("dms/agent/listAgents").subscribe(data => {
      console.log(data);
      this.agentsDataSet = this.tempTransform(data)
      if (this.messageId) this.msg.remove(this.messageId);
    });
  }

  firstNameReq = true;


  ngAfterViewInit(): void {

    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].updateValueAndValidity();
    }

    this.validateForm.get('stateCd').valueChanges.subscribe(val => {
      this.provinceStateCdChanged(val)
    });

    this.validateForm.get('companyCd').valueChanges.subscribe(val => {
      this.partnerNamesCompanyChanged(val)
    });

    this.validateForm.get('divisionCd').valueChanges.subscribe(val => {
      this.divisionChanged(val)
    });
  }

  logMessages() {
    console.log(this.validateForm.get('emailId').errors)
  }

  isRequired(fieldName) {
    let returnObj = this.validationUtilService.isRequired(fieldName, this.AGENTREGISTRATIONFORMNAME)
    return returnObj
  }


  initializeNewAgentRegistrationForm() {
    this.validateForm = this.fb.group({
      firstName: this.validationUtilService.setValidationsForFormControl('firstName', this.AGENTREGISTRATIONFORMNAME),
      userRoleCd: this.validationUtilService.setValidationsForFormControl('userRoleCd', this.AGENTREGISTRATIONFORMNAME),
      userStatusCd: this.validationUtilService.setValidationsForFormControl('userStatusCd', this.AGENTREGISTRATIONFORMNAME),
      companyContactUserId: this.validationUtilService.setValidationsForFormControl('companyContactUserId', this.AGENTREGISTRATIONFORMNAME),
      contactPerson: this.validationUtilService.setValidationsForFormControl('contactPerson', this.AGENTREGISTRATIONFORMNAME),
      agentDesignationCd: this.validationUtilService.setValidationsForFormControl('agentDesignationCd', this.AGENTREGISTRATIONFORMNAME),
      countryCd: this.validationUtilService.setValidationsForFormControl('countryCd', this.AGENTREGISTRATIONFORMNAME, this.appMetadataHandler.currentCountryCdValue),
      cityCd: this.validationUtilService.setValidationsForFormControl('cityCd', this.AGENTREGISTRATIONFORMNAME),
      divisionCd: this.validationUtilService.setValidationsForFormControl('divisionCd', this.AGENTREGISTRATIONFORMNAME),
      subDivisionCd: this.validationUtilService.setValidationsForFormControl('subDivisionCd', this.AGENTREGISTRATIONFORMNAME),
      partnerName: this.validationUtilService.setValidationsForFormControl('partnerName', this.AGENTREGISTRATIONFORMNAME),
      clientTypeCd: this.validationUtilService.setValidationsForFormControl('clientTypeCd', this.AGENTREGISTRATIONFORMNAME),
      licenseIssueDt: this.validationUtilService.setValidationsForFormControl('licenseIssueDt', this.AGENTREGISTRATIONFORMNAME),
      licenseExpiryDt: this.validationUtilService.setValidationsForFormControl('licenseExpiryDt', this.AGENTREGISTRATIONFORMNAME),
      licenseNum: this.validationUtilService.setValidationsForFormControl('licenseNum', this.AGENTREGISTRATIONFORMNAME),
      categoryCd: this.validationUtilService.setValidationsForFormControl('categoryCd', this.AGENTREGISTRATIONFORMNAME),
      channelCd: this.validationUtilService.setValidationsForFormControl('channelCd', this.AGENTREGISTRATIONFORMNAME),
      subChannelCd: this.validationUtilService.setValidationsForFormControl('subChannelCd', this.AGENTREGISTRATIONFORMNAME),
      emailId: this.validationUtilService.setValidationsForFormControl('emailId', this.AGENTREGISTRATIONFORMNAME),
      statusCd: this.validationUtilService.setValidationsForFormControl('statusCd', this.AGENTREGISTRATIONFORMNAME),
      mobileNum: this.validationUtilService.setValidationsForFormControl('mobileNum', this.AGENTREGISTRATIONFORMNAME),
      workNum: this.validationUtilService.setValidationsForFormControl('workNum', this.AGENTREGISTRATIONFORMNAME),
      addressLine1: this.validationUtilService.setValidationsForFormControl('addressLine1', this.AGENTREGISTRATIONFORMNAME),
      addressLine2: this.validationUtilService.setValidationsForFormControl('addressLine2', this.AGENTREGISTRATIONFORMNAME),
      postCode: this.validationUtilService.setValidationsForFormControl('postCode', this.AGENTREGISTRATIONFORMNAME),
      stateCd: this.validationUtilService.setValidationsForFormControl('stateCd', this.AGENTREGISTRATIONFORMNAME),
      vatApplicableFl: this.validationUtilService.setValidationsForFormControl('vatApplicableFl', this.AGENTREGISTRATIONFORMNAME),
      aegisId: this.validationUtilService.setValidationsForFormControl('aegisId', this.AGENTREGISTRATIONFORMNAME),
      cgissId: this.validationUtilService.setValidationsForFormControl('cgissId', this.AGENTREGISTRATIONFORMNAME),
      integralId: this.validationUtilService.setValidationsForFormControl('integralId', this.AGENTREGISTRATIONFORMNAME),
      roles: this.validationUtilService.setValidationsForFormControl('roles', this.AGENTREGISTRATIONFORMNAME),
      agentType: this.validationUtilService.setValidationsForFormControl('agentType', this.AGENTREGISTRATIONFORMNAME),
      lastName: this.validationUtilService.setValidationsForFormControl('lastName', this.AGENTREGISTRATIONFORMNAME),
      companyCd: this.validationUtilService.setValidationsForFormControl('companyCd', this.AGENTREGISTRATIONFORMNAME),
      companyBranchCd: this.validationUtilService.setValidationsForFormControl('companyBranchCd', this.AGENTREGISTRATIONFORMNAME),
      companyName: this.validationUtilService.setValidationsForFormControl('companyName', this.AGENTREGISTRATIONFORMNAME),
      branchName: this.validationUtilService.setValidationsForFormControl('branchName', this.AGENTREGISTRATIONFORMNAME),
      employeeID: this.validationUtilService.setValidationsForFormControl('employeeID', this.AGENTREGISTRATIONFORMNAME),
      managerUserId: this.validationUtilService.setValidationsForFormControl('managerUserId', this.AGENTREGISTRATIONFORMNAME),
      commissionAndMaxAcqValue: this.validationUtilService.setValidationsForFormControl('commissionAndMaxAcqValue', this.AGENTREGISTRATIONFORMNAME),

      mode: this.validationUtilService.setValidationsForFormControl('mode', this.AGENTREGISTRATIONFORMNAME),
      userId: this.validationUtilService.setValidationsForFormControl('userId', this.AGENTREGISTRATIONFORMNAME),
      agentid: this.validationUtilService.setValidationsForFormControl('agentid', this.AGENTREGISTRATIONFORMNAME),
      agentGuid: this.validationUtilService.setValidationsForFormControl('agentGuid', this.AGENTREGISTRATIONFORMNAME),
      clientid: this.validationUtilService.setValidationsForFormControl('clientid', this.AGENTREGISTRATIONFORMNAME),
      clientGuid: this.validationUtilService.setValidationsForFormControl('clientGuid', this.AGENTREGISTRATIONFORMNAME),
      agentNum: this.validationUtilService.setValidationsForFormControl('agentNum', this.AGENTREGISTRATIONFORMNAME),
      personOrgId: this.validationUtilService.setValidationsForFormControl('personOrgId', this.AGENTREGISTRATIONFORMNAME),
      personOrgGuid: this.validationUtilService.setValidationsForFormControl('personOrgGuid', this.AGENTREGISTRATIONFORMNAME),
    });
  }

  setCountry() {
    this.validateForm.patchValue({
      countryCd: this.appMetadataHandler.currentCountryCdValue
    });

  }

  initializeAgentRegistrationForm(response) {

    if (typeof response.agentDO == "undefined") return false;

    this.validateForm = this.fb.group({
      agentid: this.validationUtilService.setValidationsForFormControl('agentid', this.AGENTREGISTRATIONFORMNAME, response.agentDO.id),
      userId: this.validationUtilService.setValidationsForFormControl('userId', this.AGENTREGISTRATIONFORMNAME, response.agentDO.userId),
      agentNum: this.validationUtilService.setValidationsForFormControl('agentNum', this.AGENTREGISTRATIONFORMNAME, response.agentDO.agentNum),
      agentGuid: this.validationUtilService.setValidationsForFormControl('agentGuid', this.AGENTREGISTRATIONFORMNAME, response.agentDO.guid),
      licenseIssueDt: this.validationUtilService.setValidationsForFormControl('licenseIssueDt', this.AGENTREGISTRATIONFORMNAME, new Date(response.agentDO.licenseIssueDt)),
      licenseExpiryDt: this.validationUtilService.setValidationsForFormControl('licenseExpiryDt', this.AGENTREGISTRATIONFORMNAME, new Date(response.agentDO.licenseExpiryDt)),
      licenseNum: this.validationUtilService.setValidationsForFormControl('licenseNum', this.AGENTREGISTRATIONFORMNAME, response.agentDO.licenseNum),
      categoryCd: this.validationUtilService.setValidationsForFormControl('categoryCd', this.AGENTREGISTRATIONFORMNAME, response.agentDO.categoryCd),
      channelCd: this.validationUtilService.setValidationsForFormControl('channelCd', this.AGENTREGISTRATIONFORMNAME, response.agentDO.channelCd),
      subChannelCd: this.validationUtilService.setValidationsForFormControl('subChannelCd', this.AGENTREGISTRATIONFORMNAME, response.agentDO.subChannelCd),
      divisionCd: this.validationUtilService.setValidationsForFormControl('divisionCd', this.AGENTREGISTRATIONFORMNAME, response.agentDO.divisionCd),
      subDivisionCd: this.validationUtilService.setValidationsForFormControl('subDivisionCd', this.AGENTREGISTRATIONFORMNAME, response.agentDO.subDivisionCd),
      statusCd: this.validationUtilService.setValidationsForFormControl('statusCd', this.AGENTREGISTRATIONFORMNAME, response.agentDO.statusCd),
      vatApplicableFl: this.validationUtilService.setValidationsForFormControl('vatApplicableFl', this.AGENTREGISTRATIONFORMNAME, response.agentDO.vatApplicableFl),
      companyCd: this.validationUtilService.setValidationsForFormControl('companyCd', this.AGENTREGISTRATIONFORMNAME, response.agentDO.companyCd),
      companyBranchCd: this.validationUtilService.setValidationsForFormControl('companyBranchCd', this.AGENTREGISTRATIONFORMNAME, this.getCompanyBranchCdDOs(response)),
      companyName: this.validationUtilService.setValidationsForFormControl('companyName', this.AGENTREGISTRATIONFORMNAME, this.getOrgCompanyName(response)),
      branchName: this.validationUtilService.setValidationsForFormControl('branchName', this.AGENTREGISTRATIONFORMNAME, response.agentDO.branchName),
      employeeID: this.validationUtilService.setValidationsForFormControl('employeeID', this.AGENTREGISTRATIONFORMNAME, response.agentDO.employeeID),
      agentDesignationCd: this.validationUtilService.setValidationsForFormControl('agentDesignationCd', this.AGENTREGISTRATIONFORMNAME, response.agentDO.designationCd),
      companyContactUserId: this.validationUtilService.setValidationsForFormControl('companyContactUserId', this.AGENTREGISTRATIONFORMNAME, response.agentDO.companyContactUserId),
      contactPerson: this.validationUtilService.setValidationsForFormControl('contactPerson', this.AGENTREGISTRATIONFORMNAME, this.getOrgContactPerson(response)),
      partnerName: this.validationUtilService.setValidationsForFormControl('partnerName', this.AGENTREGISTRATIONFORMNAME, response.agentDO.partnerName),
      agentType: this.validationUtilService.setValidationsForFormControl('agentType', this.AGENTREGISTRATIONFORMNAME),
      managerUserId: this.validationUtilService.setValidationsForFormControl('managerUserId', this.AGENTREGISTRATIONFORMNAME, response.agentDO.managerUserId),
      roles: this.validationUtilService.setValidationsForFormControl('roles', this.AGENTREGISTRATIONFORMNAME, this.getUserRoleDOs(response)),
      commissionAndMaxAcqValue: this.validationUtilService.setValidationsForFormControl('commissionAndMaxAcqValue', this.AGENTREGISTRATIONFORMNAME, this.getPartnerBranchAgentProductMapDOs(response)),

      clientid: this.validationUtilService.setValidationsForFormControl('clientid', this.AGENTREGISTRATIONFORMNAME, response.clientDO.id),
      clientGuid: this.validationUtilService.setValidationsForFormControl('clientGuid', this.AGENTREGISTRATIONFORMNAME, response.clientDO.guid),
      firstName: this.validationUtilService.setValidationsForFormControl('firstName', this.AGENTREGISTRATIONFORMNAME, this.getFirstName(response)),
      lastName: this.validationUtilService.setValidationsForFormControl('lastName', this.AGENTREGISTRATIONFORMNAME, this.getLastName(response)),
      clientTypeCd: this.validationUtilService.setValidationsForFormControl('clientTypeCd', this.AGENTREGISTRATIONFORMNAME, response.clientDO.clientTypeCd),
      personOrgId: this.validationUtilService.setValidationsForFormControl('personOrgId', this.AGENTREGISTRATIONFORMNAME, this.getPersonOrgId(response)),
      personOrgGuid: this.validationUtilService.setValidationsForFormControl('personOrgGuid', this.AGENTREGISTRATIONFORMNAME, this.getPersonOrgGuid(response)),

      mobileNum: this.validationUtilService.setValidationsForFormControl('mobileNum', this.AGENTREGISTRATIONFORMNAME, this.getContactFromResponseList(response, 'MOBILE')),
      workNum: this.validationUtilService.setValidationsForFormControl('workNum', this.AGENTREGISTRATIONFORMNAME, this.getContactFromResponseList(response, 'WORK')),
      emailId: this.validationUtilService.setValidationsForFormControl('emailId', this.AGENTREGISTRATIONFORMNAME, this.getEmailFromResponseList(response)),

      countryCd: this.validationUtilService.setValidationsForFormControl('countryCd', this.AGENTREGISTRATIONFORMNAME, response.clientDO.clientAddressList[0].countryCd),
      cityCd: this.validationUtilService.setValidationsForFormControl('cityCd', this.AGENTREGISTRATIONFORMNAME, response.clientDO.clientAddressList[0].cityCd),
      stateCd: this.validationUtilService.setValidationsForFormControl('stateCd', this.AGENTREGISTRATIONFORMNAME, response.clientDO.clientAddressList[0].stateCd),
      addressLine1: this.validationUtilService.setValidationsForFormControl('addressLine1', this.AGENTREGISTRATIONFORMNAME, response.clientDO.clientAddressList[0].addressLine1),
      addressLine2: this.validationUtilService.setValidationsForFormControl('addressLine2', this.AGENTREGISTRATIONFORMNAME, response.clientDO.clientAddressList[0].addressLine2),
      postCode: this.validationUtilService.setValidationsForFormControl('postCode', this.AGENTREGISTRATIONFORMNAME, response.clientDO.clientAddressList[0].postCode),

      mode: this.validationUtilService.setValidationsForFormControl('mode', this.AGENTREGISTRATIONFORMNAME),
      userRoleCd: this.validationUtilService.setValidationsForFormControl('userRoleCd', this.AGENTREGISTRATIONFORMNAME),
      userStatusCd: this.validationUtilService.setValidationsForFormControl('userStatusCd', this.AGENTREGISTRATIONFORMNAME)
    });

    console.log("PartnerNames");
    console.log(this.partnerNames);
    this.partnerNamesCompanyChanged(this.validateForm.get('companyCd').value)
    this.provinceStateCdChanged(this.validateForm.get('stateCd').value)

  }

  patchValueToAgentRegistrationForm(response) {

    if (typeof response.agentDO == "undefined") return false;

    this.validateForm = this.fb.group({

      agentid: response.agentDO.id,
      agentNum: response.agentDO.agentNum,
      userId: response.agentDO.userId,
      agentGuid: response.agentDO.guid,
      licenseIssueDt: new Date(response.agentDO.licenseIssueDt),
      licenseExpiryDt: new Date(response.agentDO.licenseExpiryDt),
      licenseNum: response.agentDO.licenseNum,
      categoryCd: response.agentDO.categoryCd,
      channelCd: response.agentDO.channelCd,
      subChannelCd: response.agentDO.subChannelCd,
      divisionCd: response.agentDO.divisionCd,
      subDivisionCd: response.agentDO.subDivisionCd,
      statusCd: response.agentDO.statusCd,
      vatApplicableFl: response.agentDO.vatApplicableFl,
      companyCd: response.agentDO.companyCd,
      companyBranchCd: response.agentDO.companyBranchCd,
      companyName: this.getOrgCompanyName(response),
      branchName: response.agentDO.branchName,
      employeeID: response.agentDO.employeeID,
      agentDesignationCd: response.agentDO.designationCd,
      companyContactUserId: response.agentDO.companyContactUserId,
      contactPerson: this.getOrgContactPerson(response),
      partnerName: response.agentDO.partnerName,
      agentType: response.agentDO.categoryCd,
      managerUserId: response.agentDO.managerUserId,
      roles: this.getUserRoleDOs(response),
      commissionAndMaxAcqValue: this.getPartnerBranchAgentProductMapDOs(response),

      clientid: response.clientDO.id,
      clientGuid: response.clientDO.guid,
      firstName: this.getFirstName(response),
      lastName: this.getLastName(response),
      clientTypeCd: response.clientDO.clientTypeCd,
      personOrgId: this.getPersonOrgId(response),
      personOrgGuid: this.getPersonOrgGuid(response),

      mobileNum: this.getContactFromResponseList(response, 'MOBILE'),
      workNum: this.getContactFromResponseList(response, 'WORK'),
      emailId: this.getEmailFromResponseList(response),

      countryCd: response.clientDO.clientAddressList[0].countryCd,
      cityCd: response.clientDO.clientAddressList[0].cityCd,
      stateCd: response.clientDO.clientAddressList[0].stateCd,
      addressLine1: response.clientDO.clientAddressList[0].addressLine1,
      addressLine2: response.clientDO.clientAddressList[0].addressLine2,
      postCode: response.clientDO.clientAddressList[0].postCode,

      // userRoleCd', this.AGENTREGISTRATIONFORMNAME
      // userStatusCd', this.AGENTREGISTRATIONFORMNAME
      // aegisId', this.AGENTREGISTRATIONFORMNAME
      // cgissId', this.AGENTREGISTRATIONFORMNAME
      // integralId', this.AGENTREGISTRATIONFORMNAME

    });

    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].updateValueAndValidity();
    }

    this.partnerNamesCompanyChanged(this.validateForm.get('companyCd').value)
    this.provinceStateCdChanged(this.validateForm.get('stateCd').value)
  }


  applyChangeListeners() {
    // this.validateForm.get('stateCd').valueChanges.subscribe(val => {
    //   this.provinceStateCdChanged(val)
    // });

    // this.validateForm.get('companyCd').valueChanges.subscribe(val => {
    //   this.partnerNamesCompanyChanged(val)
    // });

    // this.validateForm.get('divisionCd').valueChanges.subscribe(val => {
    //   this.divisionChanged(val)
    // });
  }

  sortObject(k, o, orderby) {
    return o.sort(this.compareValues(k, orderby))
  }

  sortDateObject(k, o, orderby) {
    return o.sort(this.compareDateValues(k, orderby))
  }



  compareValues(key, order) {
    return function (a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }

      const varA = (typeof a[key] === 'string') ?
        a[key].toUpperCase() : a[key];
      const varB = (typeof b[key] === 'string') ?
        b[key].toUpperCase() : b[key];

      let comparison = 0;
      if (varA > varB) {
        comparison = 1;
      } else if (varA < varB) {
        comparison = -1;
      }
      return (
        (order == 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  compareDateValues(key, order) {
    return function (a, b) {
      if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
        // property doesn't exist on either object
        return 0;
      }

      const varA = moment((typeof a[key] === 'string') ?
        a[key].toUpperCase() : a[key], 'DD-MM-YYYY');
      const varB = moment((typeof b[key] === 'string') ?
        b[key].toUpperCase() : b[key], 'DD-MM-YYYY');

      let comparison = 0;
      /*
      moment('2010-10-20').isBefore('2010-12-31', 'year'); // false
      moment('2010-10-20').isBefore('2011-01-01', 'year'); // true

      moment('2010-10-20').isAfter('2010-01-01', 'year'); // false
      moment('2010-10-20').isAfter('2009-12-31', 'year'); // true
      */

      if (varA.isAfter(varB)) {
        comparison = 1;
      } else if (varB.isAfter(varA)) {
        comparison = -1;
      }
      return (
        (order == 'desc') ? (comparison * -1) : comparison
      );
    };
  }

  sortByColumn(key) {
    var basicData = this.sortObject(key, this.agentsDataSet, 'asc')

    this.agentsDataSet = JSON.parse(JSON.stringify(basicData))
  }

  sortByColumnByDate(key) {
    var basicData = this.sortDateObject(key, this.agentsDataSet, 'desc')

    this.agentsDataSet = JSON.parse(JSON.stringify(basicData))
  }




  /* Products */
  get formArr() {
    return this.productForm.get('products') as FormArray;
  }
  initItemRows() {
    return this.fb.group({
      productId: [null],
      productMaxAcqCost: [null],
      commDistributionPrct: [null]
    });
  }

  initItemRowsWithValue(productid, MaxAcq, CommPrct) {
    return this.fb.group({
      productId: [productid],
      productMaxAcqCost: [MaxAcq],
      commDistributionPrct: [CommPrct]
    });
  }

  addNewRow() {
    this.formArr.push(this.initItemRows());
    console.log(this.formArr)
  }
  deleteRow(index: number) {
    this.formArr.removeAt(index);
  }



  /* Agent Registration Form -- Edit/Create */
  formDetailsFetchRun: number = 0;
  cityLookupCall
  getAgentRegnFormData() {

    if (this.formDetailsFetchRun > 0) return true;

    this.apiRequest.get("lookupMaster/v2/userRoleCd").subscribe(data => { this.userRoleCd = data.lookupdata });
    this.apiRequest.get("lookupMaster/v2/userStatusCd").subscribe(data => { this.userStatusCd = data.lookupdata });
    //this.apiRequest.get("lookupMaster/v2clientTypeCd").subscribe(data=>{this.clientTypeCd = data}); /* not used -- Types are hardcoded */
    this.apiRequest.get("lookupMaster/v2/channelCd").subscribe(data => { this.channelCdLookup = data.lookupdata });
    this.apiRequest.get("lookupMaster/v2/subChannelCd").subscribe(data => { this.subChannelCdLookup = data.lookupdata });
    this.apiRequest.get("lookupMaster/v2/agentCategoryCd").subscribe(data => { this.agentCategoryCd = data.lookupdata });

    this.apiRequest.get("lookupMaster/v2/contactPerson").subscribe(data => { this.contactPersonLookup = data.lookupdata });
    this.apiRequest.get("lookupMaster/v2/agentDesignationCd").subscribe(data => { this.agentDesignationCd = data.lookupdata });

    this.apiRequest.get("api/product/fetchByProductStatusAndPlanType/LAUNCHED/BASEPLAN").subscribe(data => { this.productsList = data.lookupdata });

    this.apiRequest.get("lookupMaster/v2/divisionCd").subscribe(data => { this.divisionCdLookup = data.lookupdata });
    this.apiRequest.get("lookupMaster/v2/subDivisionCd").subscribe(data => { this.subDivisionCd = data.lookupdata; this.subDivisionCdFiltered = data.lookupdata; });

    this.apiRequest.get("partner/fetchAllPartnerNames").subscribe(
      data => {
        this.partnerNames = data.map((a, index) => {  /* Resp: Array of arrays */
          return { 'lookupKey': "" + a[0], 'lookupValue': a[1] }
        });
      });

    /* State / Province */
    this.apiRequest.get("province/fetchAll").subscribe(data => { this.provinces = data });
    /* Cities */
    this.cityLookupCall = this.apiRequest.get("lookupMaster/v2/cityCd").subscribe(data => { this.cityCdLookup = data.lookupdata });
    /* province/loadCitiesForProvince/ */
    /* Country */
    this.apiRequest.get("lookupMaster/v2/countryCd").subscribe(data => {
      this.countryLookup = data.lookupdata;
      this.countryCd = this.appMetadataHandler.currentCountryCdValue;
      this.agent.countryCd = this.appMetadataHandler.currentCountryCdValue; /* Set Indonesia */
      this.countryCdDdDisabled = true;
    });



    /* Increment Run Counter*/
    this.formDetailsFetchRun = this.formDetailsFetchRun + 1;
  }



  /* Update dropdown values on model changes */
  partnerNamesCompanyChanged(companyId: number) {
    if (!!companyId) /* Fetch Sub Divisions on Partner/Co. name change */
      this.apiRequest.get("partner/fetchBranchNames/" + companyId).subscribe(
        data => {
          // this.nullifyCompanyBranch();/* This doesn't work */
          this.branchNames = data.map((a, index) => {  /* Resp: Array of arrays */
            return { 'lookupKey': a[0], 'lookupValue': a[1] }
          });
        });
  }
  divisionChanged(divisionKey: string) {
    this.nullifySubDivision() /* Reset */
    if (this.subDivisionCd && this.subDivisionCd.length > 0)
      this.subDivisionCdFiltered = this.subDivisionCd.filter(item => { /* Filter */
        return item.parentLookupCd === divisionKey;
      })
  }
  provinceStateCdChanged(stateCd: string) {
    this.agent.cityCd = null; /* Reset */
    this.apiRequest.get("province/loadCitiesForProvince/" + stateCd).subscribe(
      data => {
        this.cityCdLookup = data.map((i, index) => {
          return { 'lookupKey': i.cityCd, 'lookupValue': i.cityName }
        });
      });

  } /* /ngOnInit() */

  AGENTREGISTRATIONFORMNAME = 'agentRegistration'
  randomNum(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  disabledExpiryDate = (current: Date): boolean => {
    // Can not select days before today and today
    var today = moment(this.validateForm.get('licenseIssueDt').value)
    let currentDate = moment(current);
    let diff = today.diff(currentDate, 'days')
    return diff > -1;
  };

  disabledIssueDate = (current: Date): boolean => {
    // Can not select days before today and today
    var today = moment()
    let currentDate = moment(current);
    let diff = today.diff(currentDate, 'days')
    return diff > 0;
  };

  nullifyExpiryDate() {
    this.validateForm.get('licenseExpiryDt').reset()
  }

  nullifySubDivision() {
    this.validateForm.get('subDivisionCd').reset()
  }

  nullifyCompanyBranch() {
    this.validateForm.get('companyBranchCd').reset()
  }

  getControlName = (control: AbstractControl) => {
    var controlName = null;
    var parent = control["_parent"];

    // only such parent, which is FormGroup, has a dictionary 
    // with control-names as a key and a form-control as a value
    if (parent instanceof FormGroup) {
      // now we will iterate those keys (i.e. names of controls)
      Object.keys(parent.controls).forEach((name) => {
        // and compare the passed control and 
        // a child control of a parent - with provided name (we iterate them all)
        if (control === parent.controls[name]) {
          // both are same: control passed to Validator
          //  and this child - are the same references
          controlName = name;
        }
      });
    }
    // we either found a name or simply return null
    return controlName;
  }


  checkInvalidFields(Form) {
    let invalidFields = [];
    for (const i in Form.controls) {
      if (Form.controls[i].status === 'INVALID') {
        let controlName = this.getControlName(Form.controls[i])
        console.log(Form.controls[i])
        console.log("Invalid Field Value: " + controlName + "-" + Form.controls[i].value)
        invalidFields.push(controlName)
      }
    }
    return invalidFields;
  }

  getValidateStatus(formcontrol) {
    if (this.getControlName(formcontrol) === 'postCode' && this.fetchingProviceCity) {
      return 'validating'
    }
    else if (formcontrol.dirty && formcontrol.errors)
      return 'error'
    else
      return null
  }

  validateMaxAcqCostAndCommission(): boolean {
    var emptyDO = {
      "parentObject": null,
      "versionId": null,
      "guid": null,
      "createdDt": null,
      "updatedDt": null,
      "createdUser": null,
      "updatedUser": null,
      "caseManager": null,
      "exceptionDOList": null,
      "id": null,
      "productId": null,
      "statusCd": null,
      "partnerId": null,
      "branchId": null,
      "agentId": null,
      "maxAcqusitionCostPrct": null,
      "commDistributionPrct": null,
      "objectName": "PartnerBranchAgentProductMapDO"
    }

    var statusDO = { productId: null, validationStatus: null }

    for (let item of this.formArr.value) {
      let newtempObj = JSON.parse(JSON.stringify(emptyDO));
      newtempObj.productId = item.productId
      newtempObj.maxAcqusitionCostPrct = item.productMaxAcqCost
      newtempObj.commDistributionPrct = item.commDistributionPrct

      if (newtempObj.productId === null
        && ((newtempObj.maxAcqusitionCostPrct != null && newtempObj.maxAcqusitionCostPrct.trim() === "")
          || (newtempObj.commDistributionPrct != null && newtempObj.commDistributionPrct.trim() != ""))) {
        this.notification.error('Product Not Selected!', 'Product Not selected for a row')
        this.validateMaxAcqCostAndComm = false;
        return false;
      }
      if (newtempObj.productId !== null && newtempObj.maxAcqusitionCostPrct === null && newtempObj.commDistributionPrct === null) {
        this.notification.error('Value missing!', 'Value Missing for the Selected Product')
        this.validateMaxAcqCostAndComm = false;
        return false
      }
      // if (newtempObj.productId != null && (newtempObj.maxAcqusitionCostPrct != null || newtempObj.commDistributionPrct != null)) {
      //   return true
      // }
      // if (newtempObj.productId === null && (newtempObj.maxAcqusitionCostPrct === null || newtempObj.maxAcqusitionCostPrct == "") && (newtempObj.commDistributionPrct === null || newtempObj.commDistributionPrct == "")) {
      //   return true
      // }



    }

    return true

  }

  validateMaxAcqCostAndComm = true;

  attemptToSubmit() {
    this.setCountry()
    this.checkInvalidFields(this.validateForm)
    var validateMaxAcqCostAndCommission: boolean = this.validateMaxAcqCostAndCommission()
    // var validateMaxAcqCostAndCommission:any = true

    /* Reset */
    // for (const i in this.validateForm.controls) {
    //   this.validateForm.controls[i].markAsDirty();
    //   this.validateForm.controls[i].updateValueAndValidity();
    // }
    //Submit if the Form is Valid

    if (validateMaxAcqCostAndCommission) {
      if (this.validateForm.valid) {
        this.submitForm(this.validateForm.get('mode').value);
      }

      else {
        //Submit if the Form is not Valid But 
        if (this.validateForm.get('clientTypeCd').value != 'PERSON' && !this.validateForm.get('firstName').valid && this.firstNameErrorOnly(this.validateForm)) {
          this.submitForm(this.validateForm.get('mode').value)
        }
        else if (this.validateForm.get('clientTypeCd').value != 'ORGANIZATION' && this.companyNameContactpersonErrorOnly(this.validateForm)) {
          this.submitForm(this.validateForm.get('mode').value)
        }
        else {
          this.notification.error('Error Occured', 'The Data entered has errors', { nzDuration: 2000 });
        }
      }
    }
  }

  firstNameErrorOnly(Form) {
    let invalidFields = this.checkInvalidFields(Form)

    if (invalidFields && invalidFields.length === 1 && invalidFields[0] === 'firstName') {
      return true
    }
    else
      return false
  }

  companyNameContactpersonErrorOnly(Form) {
    let invalidFields = this.checkInvalidFields(Form)
    let invalidCompanyNameList = invalidFields.filter(f => f === 'companyName')
    let invalidContactPersonList = invalidFields.filter(f => f === 'contactPerson')

    let conditionOfTwoInvalidFields = (invalidFields.length == 2 && invalidCompanyNameList.length > 0 && invalidContactPersonList.length > 0)
    let conditionOfOneInvlidField = (invalidFields.length == 1 && (invalidCompanyNameList.length > 0 || invalidContactPersonList.length > 0))

    if (invalidFields && (conditionOfTwoInvalidFields || conditionOfOneInvlidField)) {
      return true
    }
    else
      return false
  }

  submitForm(mode?): void {
    this.isConfirmLoading = true;

    var payload = this.UIDOToServerDOForAgentRegistration(this.validateForm)

    this.agentService.saveAgent(payload).subscribe(resp => {
      console.log(resp)
      this.isConfirmLoading = false;
      if (resp.exceptionDOList === null || !resp.exceptionDOList) {
        this.agentSuccessfullyRegistered(resp, this.validateForm, mode)
      }
      else {
        let errorList = this.getListOfAllServerExceptionString(resp)
        this.notification.error('Error Occured(' + resp.exceptionDOList.length + ')', 'Agent has been not been registered due to following errors: ' + errorList);
      }


    })

  }

  getListOfAllServerExceptionString(response) {
    let msgList = ""
    let e = response.exceptionDOList
    if (response && e != null && e != undefined) {
      e.forEach((eitem, index) => {
        msgList += (index + 1) + ". " + eitem.exceptionMessage + " "
      })
    }

    return msgList
  }

  agentSuccessfullyRegistered(resp, formObject, mode?) {

    var createTempObj
    if (resp.clientDO.clientTypeCd === 'PERSON') {
      createTempObj = [
        [resp.agentDO.id,
        resp.clientDO.personDO.firstName,
        resp.clientDO.personDO.lastName,
        resp.agentDO.userId,
        resp.agentDO.companyCd,
        resp.agentDO.designationCd,
        resp.agentDO.licenseExpiryDt,
        resp.agentDO.companyCd,
        resp.agentDO.statusCd
        ]]
    }
    else if (resp.clientDO.clientTypeCd === 'ORGANIZATION') {

      createTempObj = [
        [resp.agentDO.id,
        resp.clientDO.organisationDO.companyName,
          "",
        resp.agentDO.userId,
        resp.agentDO.companyCd,
        resp.agentDO.designationCd,
        resp.agentDO.licenseExpiryDt,
        resp.agentDO.companyCd,
        resp.agentDO.statusCd
        ]]
    }


    // let matched = this.agentsDataSet.filter(agent => agent.id === resp.agentDO.id)
    // if (matched.length > 0) {
    //   this.agentsDataSet.map(obj => createTempObj.find(o => o[0] === obj.id) || obj);
    // }
    // else {
    //   this.agentsDataSet.push(...this.tempTransform(createTempObj))
    // }

    this.fetchAgentList()

    if (mode === "edit") {
      this.notification.success('Success!', 'The Agent data has been successfully updated')
    }
    else if (mode === "add") {
      this.notification.success('Success!', 'The Agent has been successfully registered, and will receive OTP on ' + formObject.get('emailId').value);
    }
    else {
      this.notification.success('Success!', 'The Agent data has been successfully saved')
    }



    this.handleOk()
  }

  updateConfirmValidator(): void {
    /** wait for refresh value */
    Promise.resolve().then(() => this.validateForm.controls.checkPassword.updateValueAndValidity());
  }

  confirmationValidator = (control: FormControl): { [s: string]: boolean } => {
    if (!control.value) {
      return { required: true };
    } else if (control.value !== this.validateForm.controls.password.value) {
      return { confirm: true, error: true };
    }
  };

  fetchingProviceCity = false;

  fetchProvinceAndCityByPostCode(postalCode) {
    this.setCountry();
    this.fetchingProviceCity = true;
    if (postalCode && postalCode.length === 5)
      this.clientService.getprovinceAndCities(postalCode).subscribe(resp => {

        if (postalCode != null && postalCode != undefined && postalCode != '' && this.validateForm.get('countryCd').value == 'INA') {
          if (resp[0].length > 0 && resp[0] != null && resp[0] != undefined) {
            if (resp[0][0].stateCd != null && resp[0][0].stateCd != undefined) {
              this.validateForm.controls['stateCd'].setValue(resp[0][0].stateCd);
              if (this.cityLookupCall != null)
                this.cityLookupCall.unsubscribe()
              this.cityLookupCall = this.apiRequest.get("lookupMaster/v2/cityCd").subscribe(data => { this.cityCdLookup = data.lookupdata });
              if (resp[0][0].cityCd != null && resp[0][0].cityCd != undefined) {
                this.validateForm.controls['cityCd'].setValue(resp[0][0].cityCd);
                this.fetchingProviceCity = false;
              }
            }
          } else {
            this.validateForm.controls['stateCd'].setValue(null);
            this.validateForm.controls['cityCd'].setValue(null);
          }
        }

      })
  }

  getDate(timeStamp) {
    let date = new Date(timeStamp)
    let formattedDate = date.getUTCDate() + '-' + (date.getUTCMonth() + 1) + '-' + date.getUTCFullYear()
    return formattedDate
  }


  getErrorList(fieldFormControl) {
    var controlName = this.getControlName(fieldFormControl)
    let errorlist = this.validationUtilService._getErrorMessageList(fieldFormControl.errors, controlName, this.AGENTREGISTRATIONFORMNAME)

    return errorlist
  }



  tempTransform(data) {
    let formattedListOfAgents = [];

    data.forEach(item => {
      var filledItem = {
        name: this.nameMaker(item[1],item[2]),
        id: item[0],
        // company: item[4],
        company: "SOMPO",
        designation: item[5],
        channel: item[6],
        licenseExpiry: this.getDate(item[7]),
        licenseExpiryStatus: this.findLicenseExpiryStatus(item[7]),
        status: "success",
        userId: item[3]
      }

      formattedListOfAgents.push(filledItem);
    })

    // data.forEach(item => {
    //   var filledItem = {
    //     name: this.nameMaker(item.firstName,item.lastName),
    //     id: item.id,
    //     // company: item[4],
    //     company: item.companyCd,
    //     designation: item[5],
    //     channel: item.channelCd,
    //     licenseExpiry: this.getDate(item.licenseExpiryDt),
    //     licenseExpiryStatus: this.findLicenseExpiryStatus(item.licenseExpiryDt),
    //     status: "success",
    //     userId: item.userId
    //   }

    //   formattedListOfAgents.push(filledItem);
    // })

    return formattedListOfAgents
  }


  UIDOToServerDOForAgentRegistration(UIDO: FormGroup, clientTypeCd?: string) {
    let transformedPayload = this.getEmptyAgentRegistrationPayload()
    transformedPayload.agentDO = this.setAgentDO(UIDO);
    transformedPayload.clientDO = this.setClientDO(UIDO)
    transformedPayload.partnerBranchAgentProductMapDOs = this.setPartnerBranchAgentProductMapDOs(UIDO)
    transformedPayload.userRoleDOs = this.setUserRoleDOs(UIDO)

    console.warn("Transformed Agent Payload Logged")
    console.log(transformedPayload)

    return transformedPayload
  }

  setAgentDO(UIDO: FormGroup): any {
    let returnData = new AgentDO()

    let agentid = UIDO.get('agentid').value
    let agentGuid = UIDO.get('agentGuid').value
    let agentNum = UIDO.get('agentNum').value
    returnData.id = agentid
    returnData.guid = agentGuid
    returnData.agentNum = agentNum
    returnData.userId = UIDO.get('userId').value
    returnData.channelCd = UIDO.get('channelCd').value
    returnData.statusCd = UIDO.get('statusCd').value
    returnData.subChannelCd = UIDO.get('subChannelCd').value
    returnData.designationCd = UIDO.get('agentDesignationCd').value
    returnData.licenseNum = UIDO.get('licenseNum').value
    returnData.licenseExpiryDt = UIDO.get('licenseExpiryDt').value
    returnData.licenseIssueDt = UIDO.get('licenseIssueDt').value
    returnData.categoryCd = UIDO.get('categoryCd').value
    returnData.divisionCd = UIDO.get('divisionCd').value
    returnData.subDivisionCd = UIDO.get('subDivisionCd').value
    returnData.vatApplicableFl = UIDO.get('vatApplicableFl').value
    returnData.companyCd = UIDO.get('companyCd').value
    // returnData.companyBranchCd = UIDO.get('companyBranchCd').value
    returnData.companyBranchCd = this.setCompanyBranchCdDOs(UIDO)
    returnData.partnerCd = UIDO.get('partnerName').value
    returnData.partnerbranchCd = UIDO.get('branchName').value
    returnData.partnerEmployeeNum = UIDO.get('employeeID').value
    returnData.companyContactUserId = UIDO.get('companyContactUserId').value
    returnData.managerUserId = UIDO.get('managerUserId').value
    returnData.agentAdditionalFieldDOs = this.setCgissAegissAndIntegralID(UIDO)



    return returnData
  }

  setAdditionalDOsinAgentDO(fieldValue, fieldKey) {
    let returnData = null
    returnData = new PolicyAdditionalFieldDO()
    returnData.fieldValue = fieldValue;
    returnData.fieldKey = fieldKey;

    return returnData
  }

  setCgissAegissAndIntegralID(UIDO: FormGroup) {
    let returnArray = []
    var aegisId = UIDO.get('aegisId').value;
    var cgissId = UIDO.get('cgissId').value;
    var integralId = UIDO.get('integralId').value;

    // if (aegisId && aegisId != null && aegisId.trim() != "") {
    //   returnArray.push(this.setAdditionalDOsinAgentDO(aegisId, this.appMetadataHandler.AEGISKEY))
    // }

    // if (cgissId && cgissId != null && cgissId.trim() != "") {
    //   returnArray.push(this.setAdditionalDOsinAgentDO(aegisId, this.appMetadataHandler.CGISSKEY))
    // }

    // if (integralId && integralId != null && integralId.trim() != "") {
    //   returnArray.push(this.setAdditionalDOsinAgentDO(aegisId, this.appMetadataHandler.INTEGRALKEY))
    // }

    return returnArray

  }

  getCgissAegissAndIntegralID(fieldKey, response) {
    let returnData = null
    var searchResult = null
    if (response.agentDO && response.agentDO.agentAdditionalFieldDOs != null) {
      searchResult = response.agentDO.agentAdditionalFieldDOs.filter(AddDO => {
        return fieldKey === AddDO.fieldKey
      })
      if (searchResult && searchResult.length > 0)
        returnData = JSON.parse(JSON.stringify(searchResult[0]))
      else
        return null
    }

    return returnData.fieldValue
  }

  setClientDO(UIDO: FormGroup) {
    let returnData = null
    let clientid = UIDO.get('clientid').value
    let clientGuid = UIDO.get('clientGuid').value
    let guid = clientGuid;

    let personOrgId = UIDO.get('personOrgId').value
    let personOrgGuid = UIDO.get('personOrgGuid').value

    if (guid === null)
      guid = this.commonUtilty.setGuid()
    let clientType = UIDO.get('clientTypeCd').value
    let status = UIDO.get('statusCd').value
    if (clientType === 'PERSON') {
      returnData = new ClientPersonDO();
      returnData.organisationDO = null
      returnData.personDO.id = personOrgId
      returnData.personDO.guid = personOrgGuid
      returnData.personDO.firstName = UIDO.get('firstName').value;
      returnData.personDO.lastName = UIDO.get('lastName').value;
    }
    else if (clientType === 'ORGANIZATION') {
      returnData = new ClientOrgnizationDO();
      returnData.personDO = null
      returnData.organisationDO.id = personOrgId
      returnData.organisationDO.guid = personOrgGuid
      returnData.organisationDO.companyName = UIDO.get('companyName').value;
      returnData.organisationDO.contactPersonName = UIDO.get('contactPerson').value;
    }
    else {
      returnData = null
    }

    returnData.guid = guid
    returnData.id = clientid
    returnData.stateCd = status
    returnData.duplicateFl = false
    returnData.blackListedFl = false

    //This transform is specific to single address
    returnData.clientAddressList = this.setSingleAddressForTheClient(UIDO)
    returnData.clientContactDetailsList = this.setSingleMobileAndSingleWorkNumber(UIDO)
    returnData.clientEmailList = this.setSingleEmailForTheClient(UIDO)



    return returnData
  }


  getPersonOrgId(response) {
    if (response.clientDO.clientTypeCd === 'PERSON') {
      return response.clientDO.personDO.id
    }
    else if (response.clientDO.clientTypeCd === 'ORGANIZATION') {
      return response.clientDO.organisationDO.id
    }
  }

  getFirstName(response) {
    if (response && response.clientDO && response.clientDO.clientTypeCd === 'PERSON' && response.clientDO.personDO) {
      return response.clientDO.personDO.firstName
    }
    else {
      return null
    }
  }

  getLastName(response) {
    if (response && response.clientDO && response.clientDO.clientTypeCd === 'PERSON' && response.clientDO.personDO) {
      return response.clientDO.personDO.lastName
    }
    else {
      return null
    }
  }

  getOrgCompanyName(response) {
    if (response && response.clientDO && response.clientDO.clientTypeCd === 'ORGANIZATION' && response.clientDO.organisationDO) {
      return response.clientDO.organisationDO.companyName
    }
    else {
      return null
    }
  }

  getOrgContactPerson(response) {
    if (response && response.clientDO && response.clientDO.clientTypeCd === 'ORGANIZATION' && response.clientDO.organisationDO) {
      return response.clientDO.organisationDO.contactPersonName
    }
    else {
      return null
    }
  }

  getPersonOrgGuid(response) {
    if (response.clientDO.clientTypeCd === 'PERSON') {
      return response.clientDO.personDO.guid
    }
    else if (response.clientDO.clientTypeCd === 'ORGANIZATION') {
      return response.clientDO.organisationDO.guid
    }
  }



  setSingleAddressForTheClient(UIDO: FormGroup) {
    let returnData = null
    let returnArray = []
    returnData = new ClientAddressDO()
    returnData.addressLine1 = UIDO.get('addressLine1').value;
    returnData.addressLine2 = UIDO.get('addressLine2').value;
    returnData.cityCd = UIDO.get('cityCd').value;
    returnData.stateCd = UIDO.get('stateCd').value;
    returnData.countryCd = UIDO.get('countryCd').value;
    returnData.postCode = UIDO.get('postCode').value;
    returnData.prefferedFl = true
    returnArray.push(returnData)

    return returnArray

  }

  setSingleMobileAndSingleWorkNumber(UIDO: FormGroup) {

    let contactNumber = null
    let workContactNumber = null
    let contactsList = []
    contactNumber = new ClientContactDO()
    contactNumber.typeCd = "MOBILE"
    contactNumber.contactNum = UIDO.get('mobileNum').value;
    contactNumber.prefferedFl = 1

    if (UIDO.get('workNum').value != null) {
      workContactNumber = new ClientContactDO()
      workContactNumber.typeCd = "WORK"
      workContactNumber.contactNum = UIDO.get('workNum').value;
    }

    if (contactNumber != null)
      contactsList.push(contactNumber)
    if (workContactNumber != null)
      contactsList.push(workContactNumber)

    return contactsList

  }

  getContactFromResponseList(resp, typeCd) {
    let returnContact = resp.clientDO.clientContactDetailsList.filter(contact => contact.typeCd === typeCd)

    //Assumption is there is only one number of one type
    if (returnContact.length > 0)
      return returnContact[0].contactNum
    else
      return null
  }

  setSingleEmailForTheClient(UIDO: FormGroup) {
    let returnData = null
    let returnArray = []
    returnData = new ClientEmailDO()
    returnData.typeCd = 'BUSINESS'
    returnData.emailId = UIDO.get('emailId').value;
    returnData.prefferedFl = true
    returnArray.push(returnData)

    return returnArray

  }

  getEmailFromResponseList(resp) {

    //Assumption: only email id exists
    return resp.clientDO.clientEmailList[0].emailId
  }

  setPartnerBranchAgentProductMapDOs(UIDO: FormGroup): Array<any> {

    var emptyDO = {
      "parentObject": null,
      "versionId": null,
      "guid": null,
      "createdDt": null,
      "updatedDt": null,
      "createdUser": null,
      "updatedUser": null,
      "caseManager": null,
      "exceptionDOList": null,
      "id": null,
      "productId": null,
      "statusCd": null,
      "partnerId": null,
      "branchId": null,
      "agentId": null,
      "maxAcqusitionCostPrct": null,
      "commDistributionPrct": null,
      "objectName": "PartnerBranchAgentProductMapDO"
    }
    let returnObj = []
    this.formArr.value.forEach(item => {
      let newtempObj = JSON.parse(JSON.stringify(emptyDO));
      newtempObj.productId = item.productId
      newtempObj.maxAcqusitionCostPrct = item.productMaxAcqCost
      newtempObj.commDistributionPrct = item.commDistributionPrct

      if (newtempObj.productId != null && (newtempObj.maxAcqusitionCostPrct != null || newtempObj.commDistributionPrct != null)) {
        returnObj.push(newtempObj)
      }

    })

    return returnObj
  }

  getPartnerBranchAgentProductMapDOs(response) {
    if (response && response.partnerBranchAgentProductMapDOs != null) {
      this.formArr.value.forEach(element => {

      });
      response.partnerBranchAgentProductMapDOs.forEach(item => {
        this.formArr.push(this.initItemRowsWithValue(item.productId, item.maxAcqusitionCostPrct, item.commDistributionPrct));
      })
    }
  }

  setUserRoleDOs(UIDO: FormGroup) {

    var emptyDO = {
      "parentObject": null,
      "versionId": null,
      "guid": null,
      "id": null,
      "roleId": null,
      "objectName": "UserRoleDO",
      "systemCreatedDt": null,
      "systemUpdatedDt": null,
      "systemCreatedUser": null,
      "systemUpdatedUser": null
    }

    let returnObj = []

    var roleList = UIDO.get('roles').value
    roleList.forEach(role => {
      let newUserRoleDo = JSON.parse(JSON.stringify(emptyDO));
      newUserRoleDo.roleId = role
      returnObj.push(newUserRoleDo)
    })

    return returnObj
  }

  getUserRoleDOs(response) {
    let returnObj = []

    response.userRoleDOs.forEach(UserRole => {
      returnObj.push(UserRole.roleId);
    })

    return returnObj;

  }

  setCompanyBranchCdDOs(UIDO: FormGroup) {

    let returnCSV = ""
    var branches = UIDO.get('companyBranchCd').value
    branches.forEach((branch, index) => {
      if (index < (branches.length - 1))
        returnCSV += "" + branch.trim() + ","
      else
        returnCSV += "" + branch.trim()
    })
    return returnCSV
  }

  getCompanyBranchCdDOs(response) {
    let returnObj = []
    let branchDOs = response.agentDO.companyBranchCd.split(',');
    branchDOs.forEach(branch => {
      returnObj.push(branch);
    })

    return returnObj;

  }



  getEmptyAgentRegistrationPayload() {
    var emptyPayloadold = {
      "agentDO": null,
      "clientDO": null,
      "partnerBranchAgentProductMapDOs": [],
      "userRoleDOs": []
    }

    var emptyPayload = {
      "agentDO": {
        "parentObject": null,
        "versionId": null,
        "guid": null,
        "createdDt": null,
        "updatedDt": null,
        "createdUser": null,
        "updatedUser": null,
        "exceptionDOList": null,
        "id": null,
        "agentNum": null,
        "clientId": null,
        "userId": null,
        "channelCd": "AGENT",
        "statusCd": "ACTIVE",
        "subChannelCd": "FUTURE USE",
        "designationCd": "AGENTTRAVEL",
        "licenseNum": "9028048475",
        "licenseExpiryDt": 1581724800000,
        "licenseIssueDt": 692841600000,
        "categoryCd": "SILVER",
        "partnerCd": null,
        "partnerbranchCd": null,
        "partnerEmployeeNum": null,
        "companyCd": "1",
        "companyBranchCd": "BD",
        "companyContactUserId": "autosys",
        "divisionCd": "UOB",
        "subDivisionCd": "OCCM",
        "vatApplicableFl": false,
        "clientRefGuid": null,
        "agentDeviceMappingDOList": [],
        "agentMobileSyncLogDOs": null,
        "agentAdditionalFieldDOs": [],
        "objectName": "AgentDO",
        "marketingCd": null,
        "marketingSubDiv": null
      },
      "clientDO": {
        "parentObject": null,
        "versionId": null,
        "id": null,
        "guid": "82b9cf3d-6985-484a-8da8-dddc9a6b3fe1",
        "clientTypeCd": "PERSON",
        "statusCd": "ACTIVE",
        "duplicateFl": false,
        "blackListedFl": false,
        "organisationDO": null,
        "personDO": {
          "parentObject": null,
          "versionId": null,
          "guid": null,
          "createdDt": null,
          "updatedDt": null,
          "createdUser": null,
          "updatedUser": null,
          "id": null,
          "titleCd": null,
          "firstName": "Ninad",
          "middleName": null,
          "lastName": "Kulkarni",
          "firstName1": null,
          "middleName1": null,
          "lastName1": null,
          "genderCd": null,
          "dateOfBirth": null,
          "age": null,
          "maritalStatusCd": null,
          "mothersMaidenName": null,
          "fathersName": null,
          "givenName": null,
          "legalName": null,
          "otherName": null,
          "countryOfBirthCd": null,
          "citizenshipCd": null,
          "politicalFlag": null,
          "convictedFlag": null,
          "personEmploymentList": [],
          "personIdentityList": [],
          "objectName": "PersonDO",
          "clientStatusCd": null
        },
        "clientAddressList": [
          {
            "parentObject": null,
            "versionId": null,
            "guid": null,
            "id": null,
            "clientAddressID": null,
            "typeCd": "BUSINESS",
            "addressLine1": "abc",
            "addressLine2": null,
            "addressLine3": null,
            "addressLine4": null,
            "cityCd": "JAKARTA_PUSAT",
            "talukaCd": null,
            "villageCd": null,
            "stateCd": "DKI_JAKARTA",
            "countryCd": "INA",
            "postCode": "10110",
            "prefferedFl": 1,
            "objectName": "ClientAddressDO",
            "offlineGuid": null,
            "agentDeviceSeq": null,
            "addressTypeCd": null,
            "addressSubTypeCd": null,
            "postCd": null
          }
        ],
        "clientContactDetailsList": [
          {
            "parentObject": null,
            "versionId": null,
            "guid": null,
            "createdDt": null,
            "updatedDt": null,
            "createdUser": null,
            "updatedUser": null,
            "id": null,
            "typeCd": "MOBILE",
            "subTypeCd": null,
            "contactNum": "9028048475",
            "extensionNum": null,
            "prefferedFl": 1,
            "objectName": "ClientPhoneDO",
            "isd": null,
            "std": null
          }
        ],
        "clientEmailList": [
          {
            "parentObject": null,
            "versionId": null,
            "guid": null,
            "createdDt": null,
            "updatedDt": null,
            "createdUser": null,
            "updatedUser": null,
            "caseManager": null,
            "id": null,
            "typeCd": "BUSINESS",
            "emailId": "ninad@metamorphtech.com",
            "prefferedFl": 1,
            "objectName": "ClientEmailDO"
          }
        ],
        "clientAdditionalFieldDOs": [],
        "objectName": "ClientDO",
        "offlineGuid": null,
        "agentDeviceSeq": null,
        "systemCreatedDt": null,
        "systemUpdatedDt": null,
        "onlineCreatedDt": null,
        "onlineUpdatedDt": null,
        "systemCreatedUser": null,
        "systemUpdatedUser": null,
        "customerId": null
      },
      "partnerBranchAgentProductMapDOs": [
        {
          "parentObject": null,
          "versionId": null,
          "guid": null,
          "createdDt": null,
          "updatedDt": null,
          "createdUser": null,
          "updatedUser": null,
          "caseManager": null,
          "exceptionDOList": null,
          "id": null,
          "productId": "AutoFirst",
          "statusCd": null,
          "partnerId": null,
          "branchId": null,
          "agentId": null,
          "maxAcqusitionCostPrct": "35",
          "objectName": "PartnerBranchAgentProductMapDO"
        }
      ],
      "userRoleDOs": [
        {
          "parentObject": null,
          "versionId": null,
          "guid": null,
          "id": null,
          "roleId": "TRAVELAGENT",
          "objectName": "UserRoleDO",
          "systemCreatedDt": null,
          "systemUpdatedDt": null,
          "systemCreatedUser": null,
          "systemUpdatedUser": null
        },
        {
          "parentObject": null,
          "versionId": null,
          "guid": null,
          "id": null,
          "roleId": "MOTORAGENT",
          "objectName": "UserRoleDO",
          "systemCreatedDt": null,
          "systemUpdatedDt": null,
          "systemCreatedUser": null,
          "systemUpdatedUser": null
        }
      ]
    }

    return emptyPayload;
  }



  /* Date Format */
  dateFormat: string = 'dd-MM-yyyy';

  agentsDataSet: any = [];

  /* Agent */
  agent: any = {};
  agentSelected: any = false;

  agentModalisVisible = false;
  isConfirmLoading = false;

  /* Per-Tab configs: For Code/UX*/
  actionButtonText = "Save";
  currentTab: string = 'details'; /* Submit button will be shown for details page alone */
  onPage(page: string) {
    this.currentTab = page;
    switch (page) {
      case "details":
        this.getAgentRegnFormData();
        break;
      case "view-hierarchy":
        //this.processHierarchyForAgent(this.agentSelected.id);
        break;
      case "update-reporting":
        this.actionButtonText = "Close";
        break;
      default:
        this.actionButtonText = "Save";
    }
    return true;
  }

  agentDetails: any = null;
  agentReportees: any = [];
  agentManager: any = null;
  agentHasManager: boolean = false;
  agentHierarchyIsProcessing: boolean = true;
  reportingHierarchy: any = {
    name: 'No data',
    designation: '--',
    img: "",
    subordinates: []
  };
  updateReportingOfAgent: any = null;
  agentsListDataSet: any = [];
  initResetHierarchyData() {
    this.agentDetails = null;
    this.agentReportees = [];
    this.agentManager = null;
    this.agentHasManager = false;
    this.agentHierarchyIsProcessing = true;
    this.updateReportingOfAgent = null;
    this.updateReportsTo = false;
    this.updateReportees = false;
    this.reportingHierarchy = {
      name: 'No data',
      designation: '--', img: "",
      subordinates: []
    };
    this.apiRequest.get("agent/listAgents").subscribe(data => {
      this.agentsListDataSet = data.map(item => {

        return { id: item[0], agentId: item[3], name: this.nameMaker(item[1],item[2]) || '' }

      })
    });
  }
  processHierarchyForAgent(id: number = null) {
    this.agentHierarchyIsProcessing = true;
    this.apiRequest.get("agent/fetchById/" + id).subscribe(data => {

      /* Get Agent's details (DO) */
      this.agentDetails = data;
      this.apiRequest.get("agentHierarchy/fetchHierarchy/" + this.agentDetails.agentDO.userId)
        .subscribe(data => {

          /* Reportees */
          var reportees = data.reportees;

          if (reportees != null && reportees != undefined)
            this.agentReportees = reportees.map((i, index) => {
              //Response: [1, "agentID@upp.to", "Agent", "X"], [] ... 
              return {
                'id': i[0],
                'name': this.nameMaker(i[2],i[3]),
                'designation': i[1], 'agentId': i[1],
                'img': 'https://ui-avatars.com/api/?background=333&color=FFF&size=50&name=' 
                       + this.nameMaker(i[2],i[3]),
                subordinates: [],
                /* For Select UI */
                'checked': true,
                'label': this.nameMaker(i[2],i[3]),
                'value': i[0],
              }
            });

          /* Manager */
          var manager = (typeof data.managers[0] !== undefined) ? data.managers[0] : false;
          this.agentHasManager = !!manager ? true : false;
          this.agentManager = {
            id: this.agentHasManager ? manager[0] : 0,
            name: this.agentHasManager ? this.nameMaker(manager[2],manager[3]) : '-',
            designation: this.agentHasManager ? manager[1] : '-',
          };

          /* Create Hierarchy */
          let hierarchyTemp = {
            /* Manager */
            id: this.agentManager.id,
            name: this.agentManager.name,
            designation: this.agentManager.designation,
            img: 'https://ui-avatars.com/api/?background=333&color=FFF&size=50&name=' + this.agentManager.name,
            subordinates: [
              {
                /* Current user */
                name: this.agentDetails.clientDO.name,
                designation: this.agentDetails.agentDO.userId,
                img: 'https://ui-avatars.com/api/?background=c71585&color=FFF&size=50&name=' + this.agentDetails.clientDO.name,
                /* Reportees */
                subordinates: this.agentReportees
              },
            ]
          };
          this.reportingHierarchy = hierarchyTemp;
          this.agentHierarchyIsProcessing = false;
        });
    });
  }


  agentRegistrationIsProcessing = true;
  agentRegistrationPopupTabIndex = 0

  openAgentOpsModal(data: any, stage?: any): void {
    this.agentRegistrationPopupTabIndex = 0;
    this.agentRegistrationIsProcessing = true
    this.formArr.controls = []
    this.validateForm.reset();
    this.setCountry()
    if (stage != null && (stage === 'EditAgent') && data != null) {
      this.agentService.getAgentById(data.id).subscribe(resp => {
        var received = Object.assign([], resp)
        this.agentRegistrationIsProcessing = false
        this.initializeAgentRegistrationForm(received[0]);
        this.validateForm.controls['mode'].setValue('edit');
        // this.patchValueToAgentRegistrationForm(received[0])

      })
    }
    else if (stage === 'AddAgent') {
      this.validateForm.reset();
      this.resetFormArray()
      this.agentRegistrationIsProcessing = false
      this.validateForm.controls['mode'].setValue('add');
    }
    this.initResetHierarchyData(); /* Reset Hierarchy Data */
    this.getAgentRegnFormData(); /* Get Form Data (runs once) */
    this.agentSelected = data;
    this.agentModalisVisible = true;
    if (this.agentSelected) {
      this.processHierarchyForAgent(this.agentSelected.id);
    }
  }

  resetFormArray() {
    this.formArr.controls = []

    this.addNewRow()
  }

  handleOk() {
    this.isConfirmLoading = true;
    setTimeout(() => {
      this.agentModalisVisible = false;
      this.isConfirmLoading = false;
    }, 345);
  }

  handleCancel(): void {
    this.agentModalisVisible = false;
  }
  updateReportsTo = false;
  updateReportees = false;

  allChecked = true;
  indeterminate = false;
  updateAllChecked(): void {
    this.indeterminate = false;
    if (this.allChecked) {
      this.agentReportees.forEach(item => item.checked = true);
    } else {
      this.agentReportees.forEach(item => item.checked = false);
    }
  }
  updateSingleChecked(): void {
    if (this.agentReportees.every(item => item.checked === false)) {
      this.allChecked = false;
      this.indeterminate = false;
    } else if (this.agentReportees.every(item => item.checked === true)) {
      this.allChecked = true;
      this.indeterminate = false;
    } else {
      this.indeterminate = true;
    }
  }

  agentHierarchyUpdate() {
    var data = {
      agentUserId: this.agentDetails.agentDO.userId,
      newAgentUserId: this.updateReportingOfAgent.agentId,
      upStreamFl: this.updateReportsTo ? true : false,
      downStreamCd: this.updateReportees ? 'SELECTED' : 'NONE',
      reporteeAgentUserIds: this.agentReportees.filter(item => { return true == item.checked }).map(item => item.agentId),
    };
    this.apiRequest.post("agentHierarchy/updateHierarchy", data).subscribe(data => {
      this.agentModalisVisible = false;
      this.initResetHierarchyData();
    });
  }

  /* Products */
  controlArray: any = [];

  addField(e?: MouseEvent): void {
    if (e) { e.preventDefault(); }
    const id = (this.controlArray.length > 0) ? this.controlArray[this.controlArray.length - 1].id + 1 : 0;
    const control = {
      id,
      product: `prod-${id}-Id`,
      maxAcqCost: `prod-${id}-MaxAqCost`,
      commDistributionPrct: `prod-${id}-CommDisPrct`,
    };
    const index = this.controlArray.push(control);
    console.log(this.controlArray);
    this.validateForm.addControl(this.controlArray[index - 1].product, new FormControl(null, Validators.required));
    this.validateForm.addControl(this.controlArray[index - 1].maxAcqCost, new FormControl(null, Validators.required));
  }

  removeField(i: { id: number, controlInstance: string }, e: MouseEvent): void {
    e.preventDefault();
    if (this.controlArray.length > 1) {
      const index = this.controlArray.indexOf(i);
      this.controlArray.splice(index, 1);
      this.validateForm.removeControl(i.controlInstance);
    }
  }

  getFormControl(name: string): AbstractControl {
    return this.validateForm.controls[name];
  }


  submitAgentDetails() {
  }

  findLicenseExpiryStatus(datets: string): string {
    var a = moment();
    var b = moment(datets);
    return (b.diff(a, 'days') <= 0) ? "error" : "success";
  }
  
  nameMaker(fname,lname) {
    var name = '';
    if(!!fname) name = name + <string>fname;
    if(!!lname) name = name + ' ' + <string>lname;
    return name;
  }

}

